"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrows_horizontal = void 0;
var arrows_horizontal = {
  "viewBox": "0 0 64 64",
  "children": [{
    "name": "g",
    "attribs": {
      "id": "ARROWS__x2F__HORIZONTAL_1_",
      "enable-background": "new    "
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "ARROWS__x2F__HORIZONTAL"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "ARROWS__x2F__HORIZONTAL"
        },
        "children": [{
          "name": "g",
          "attribs": {},
          "children": [{
            "name": "g",
            "attribs": {},
            "children": [{
              "name": "path",
              "attribs": {
                "d": "M3,22h32l0,0h18.182l-4.188,3.77L49,25.779c-0.609,0.549-1,1.336-1,2.222c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.771,0,1.468-0.299,2-0.778l0.007,0.008l10-9L63,21.222c0.609-0.549,1-1.337,1-2.222s-0.391-1.673-1-2.222l0.007-0.008l-10-9\r\n\t\t\t\tL53,7.778C52.468,7.3,51.771,7,51,7c-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L53.182,16H39l0,0H26l0,0\r\n\t\t\t\tH10.818l0,0H3c-1.657,0-3,1.343-3,3S1.343,22,3,22z M61,42h-7.818l0,0H38l0,0H25l0,0H10.818l4.189-3.77L15,38.223\r\n\t\t\t\tc0.61-0.55,1-1.337,1-2.223c0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.777l-0.007-0.008l-10,9L1,42.777\r\n\t\t\t\tC0.391,43.328,0,44.115,0,45s0.391,1.672,1,2.223L0.993,47.23l10,9L11,56.223C11.532,56.701,12.229,57,13,57c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.885-0.391-1.673-1-2.223l0.007-0.008L10.818,48H35l0,0h26c1.657,0,3-1.343,3-3S62.657,42,61,42z"
              },
              "children": [{
                "name": "path",
                "attribs": {
                  "d": "M3,22h32l0,0h18.182l-4.188,3.77L49,25.779c-0.609,0.549-1,1.336-1,2.222c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.771,0,1.468-0.299,2-0.778l0.007,0.008l10-9L63,21.222c0.609-0.549,1-1.337,1-2.222s-0.391-1.673-1-2.222l0.007-0.008l-10-9\r\n\t\t\t\tL53,7.778C52.468,7.3,51.771,7,51,7c-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L53.182,16H39l0,0H26l0,0\r\n\t\t\t\tH10.818l0,0H3c-1.657,0-3,1.343-3,3S1.343,22,3,22z M61,42h-7.818l0,0H38l0,0H25l0,0H10.818l4.189-3.77L15,38.223\r\n\t\t\t\tc0.61-0.55,1-1.337,1-2.223c0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.777l-0.007-0.008l-10,9L1,42.777\r\n\t\t\t\tC0.391,43.328,0,44.115,0,45s0.391,1.672,1,2.223L0.993,47.23l10,9L11,56.223C11.532,56.701,12.229,57,13,57c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.885-0.391-1.673-1-2.223l0.007-0.008L10.818,48H35l0,0h26c1.657,0,3-1.343,3-3S62.657,42,61,42z"
                },
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
exports.arrows_horizontal = arrows_horizontal;